/**
 * Directives
 * @module Accordion Component
 */
define(function (require, exports) {
    'use strict';

    exports.accordionMetro = function () {
        return {
            restrict: 'E',
            replace: true,
            template: '<div>' +
            '   <div class="ui-accordion-title" ng-click="open()">' +
            '<p>{{model.title}}</p><p>{{model.text}}</p><a href="#"></a>>Show</a></div><div ng-repeat="model in model.list"><element model="model"></element></div></div>'
        };
    };
});




// WEBPACK FOOTER //
// ./scripts/directives/accordionMetro.js